import React, { useMemo, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import "./vendor-detail.scss";

const makeProduct = (overrides = {}) => ({
  name: "No product yet",
  description: "",
  price: "",
  prepTime: "",
  image: "",
  dailyQuantity: "",
  dailySold: "0",
  dailyResetTime: "12:00 AM",
  pickupStartTime: "",
  pickupEndTime: "",
  status: "Draft",
  ...overrides,
});

const makeOutlet = (overrides = {}) => ({
  name: "No outlet yet",
  city: "-",
  state: "Sarawak",
  postcode: "",
  address: "",
  latitude: "",
  longitude: "",
  googleMapUrl: "",
  phone: "",
  openTime: "",
  closeTime: "",
  lastOrderTime: "",
  acceptingOrders: "No",
  status: "Pending Setup",
  product: makeProduct(),
  ...overrides,
});

const vendorRecords = {
  "hikari-house": {
    name: "Hikari House",
    contact: "012-3456789",
    email: "hello@hikarihouse.my",
    city: "Kuching",
    address: "Lot 12, Kuching Central, Jalan Datuk Tawi Sli",
    pic: "Channie Tan",
    status: "Active",
    ordersToday: "12",
    salesToday: "226.80",
    paidOrders: "10",
    pendingOrders: "2",
    soldToday: "9",
    joinedDate: "12 Jun 2026",
    bank: "Maybank •••• 2188",
    bankName: "Maybank",
    bankReceiverName: "Hikari House Sdn Bhd",
    bankAccountNumber: "51422188",
    outlets: [
      makeOutlet({
        name: "Kuching Central",
        city: "Kuching",
        postcode: "93300",
        address: "Lot 12, Kuching Central, Jalan Datuk Tawi Sli",
        latitude: "1.5533",
        longitude: "110.3592",
        googleMapUrl: "https://maps.google.com/?q=1.5533,110.3592",
        phone: "012-3456789",
        openTime: "10:00 AM",
        closeTime: "8:00 PM",
        lastOrderTime: "7:30 PM",
        acceptingOrders: "Yes",
        status: "Accepting Orders",
        product: makeProduct({
          name: "Chicken Katsu Bento",
          description: "Japanese chicken katsu bento with rice and side dish.",
          price: "12.90",
          prepTime: "15",
          dailyQuantity: "18",
          dailySold: "7",
          pickupStartTime: "5:30 PM",
          pickupEndTime: "7:30 PM",
          status: "Available",
        }),
      }),
      makeOutlet({
        name: "Saradise",
        city: "Kuching",
        postcode: "93350",
        address: "Saradise, Kuching",
        latitude: "1.5137",
        longitude: "110.3590",
        googleMapUrl: "https://maps.google.com/?q=1.5137,110.3590",
        phone: "012-3456799",
        openTime: "11:00 AM",
        closeTime: "8:30 PM",
        lastOrderTime: "8:00 PM",
        acceptingOrders: "Yes",
        status: "Accepting Orders",
        product: makeProduct({
          name: "Teriyaki Bento",
          description: "Teriyaki chicken bento for Saradise outlet.",
          price: "13.90",
          prepTime: "15",
          dailyQuantity: "12",
          dailySold: "2",
          pickupStartTime: "5:30 PM",
          pickupEndTime: "7:30 PM",
          status: "Available",
        }),
      }),
    ],
  },
  "green-bowl": {
    name: "Green Bowl",
    contact: "011-2233445",
    email: "orders@greenbowl.my",
    city: "Kuching",
    address: "Ground Floor, Jalan Padungan, Kuching",
    pic: "Daniel Lim",
    status: "Active",
    ordersToday: "8",
    salesToday: "92.00",
    paidOrders: "7",
    pendingOrders: "1",
    soldToday: "5",
    joinedDate: "14 Jun 2026",
    bank: "CIMB •••• 7930",
    bankName: "CIMB",
    bankReceiverName: "Green Bowl Enterprise",
    bankAccountNumber: "80187930",
    outlets: [makeOutlet({
      name: "Padungan",
      city: "Kuching",
      postcode: "93100",
      address: "Ground Floor, Jalan Padungan, Kuching",
      latitude: "1.5580",
      longitude: "110.3518",
      googleMapUrl: "https://maps.google.com/?q=1.5580,110.3518",
      phone: "011-2233445",
      openTime: "10:30 AM",
      closeTime: "7:00 PM",
      lastOrderTime: "6:30 PM",
      acceptingOrders: "Yes",
      status: "Accepting Orders",
      product: makeProduct({ name: "Healthy Rice Bowl", description: "Balanced rice bowl with vegetables and protein.", price: "11.50", prepTime: "12", dailyQuantity: "15", dailySold: "5", pickupStartTime: "5:00 PM", pickupEndTime: "7:00 PM", status: "Available" }),
    })],
  },
  "daily-bakery": {
    name: "Daily Bakery",
    contact: "016-9988776",
    email: "dailybakery@example.com",
    city: "Miri",
    address: "Lot 88, Miri Times Square",
    pic: "Mei Ling",
    status: "Pending Setup",
    ordersToday: "0",
    salesToday: "0.00",
    paidOrders: "0",
    pendingOrders: "0",
    soldToday: "0",
    joinedDate: "20 Jun 2026",
    bank: "Pending setup",
    bankName: "",
    bankReceiverName: "",
    bankAccountNumber: "",
    outlets: [],
  },
  "urban-cafe": {
    name: "Urban Cafe",
    contact: "019-7788990",
    email: "urban@example.com",
    city: "Sibu",
    address: "No. 18, Sibu Town Square",
    pic: "Alex Wong",
    status: "Inactive",
    ordersToday: "0",
    salesToday: "0.00",
    paidOrders: "0",
    pendingOrders: "0",
    soldToday: "0",
    joinedDate: "18 Jun 2026",
    bank: "Public Bank •••• 6621",
    bankName: "Public Bank",
    bankReceiverName: "Urban Cafe",
    bankAccountNumber: "30626621",
    outlets: [makeOutlet({
      name: "Sibu Town Square",
      city: "Sibu",
      postcode: "96000",
      address: "No. 18, Sibu Town Square",
      latitude: "2.2873",
      longitude: "111.8305",
      googleMapUrl: "https://maps.google.com/?q=2.2873,111.8305",
      phone: "019-7788990",
      openTime: "10:00 AM",
      closeTime: "6:00 PM",
      lastOrderTime: "5:30 PM",
      acceptingOrders: "No",
      status: "Inactive",
      product: makeProduct({ name: "Americano Combo", description: "Coffee combo for pickup.", price: "9.90", prepTime: "8", dailyQuantity: "0", dailySold: "0", pickupStartTime: "4:00 PM", pickupEndTime: "6:00 PM", status: "Hidden" }),
    })],
  },
};

const defaultVendor = {
  name: "",
  contact: "",
  email: "",
  city: "Kuching",
  address: "",
  pic: "",
  status: "Pending Setup",
  ordersToday: "0",
  salesToday: "0.00",
  paidOrders: "0",
  pendingOrders: "0",
  soldToday: "0",
  joinedDate: "28 Jun 2026",
  bank: "",
  bankName: "",
  bankReceiverName: "",
  bankAccountNumber: "",
  outlets: [],
};

const statusClass = (value) => String(value).toLowerCase().replace(/\s+/g, "-");
const slugify = (value) => String(value).toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");
const formatPrice = (value) => (value && value !== "-" ? `RM${Number(value).toFixed(2)}` : "-");
const formatBankAccount = (bankName, accountNumber) => {
  if (!bankName && !accountNumber) return "Pending setup";
  if (!accountNumber) return bankName || "Pending setup";
  const digits = String(accountNumber).replace(/\s+/g, "");
  return `${bankName || "Bank"} •••• ${digits.slice(-4)}`;
};
const timeToInput = (value) => {
  if (!value) return "";
  const match = String(value).trim().match(/^(\d{1,2}):(\d{2})\s*(AM|PM)?$/i);
  if (!match) return value;
  let hour = Number(match[1]);
  const minute = match[2];
  const period = match[3]?.toUpperCase();
  if (period === "PM" && hour < 12) hour += 12;
  if (period === "AM" && hour === 12) hour = 0;
  return `${String(hour).padStart(2, "0")}:${minute}`;
};
const inputToTime = (value) => {
  if (!value) return "";
  const [hourText, minute] = value.split(":");
  let hour = Number(hourText);
  const period = hour >= 12 ? "PM" : "AM";
  hour = hour % 12 || 12;
  return `${hour}:${minute} ${period}`;
};

const INVENTORY_RULES = {
  resetAutomatically: true,
  reduceQuantityOn: ["On Hold", "On Paid"],
  restoreQuantityOn: ["Cancelled", "Payment Timeout"],
};

const InfoItem = ({ label, value }) => (
  <div className="vendor-detail__info-item"><span>{label}</span><strong>{value || "-"}</strong></div>
);

const TextField = ({ label, value, onChange, placeholder, type = "text", readOnly = false, helpText }) => (
  <label className={`vendor-detail__field${readOnly ? " vendor-detail__field--readonly" : ""}`}>
    <span>{label}</span>
    <input type={type} value={value || ""} placeholder={placeholder} readOnly={readOnly} aria-readonly={readOnly} onChange={(event) => !readOnly && onChange?.(event.target.value)} />
    {helpText && <small>{helpText}</small>}
  </label>
);

const TimeField = ({ label, value, onChange }) => (
  <label className="vendor-detail__field"><span>{label}</span><input type="time" value={timeToInput(value)} onChange={(event) => onChange(inputToTime(event.target.value))} /></label>
);

const ImageUploadField = ({ label, value, onChange }) => {
  const hasPreview = value && String(value).startsWith("blob:");
  return (
    <label className="vendor-detail__field vendor-detail__field--upload">
      <span>{label}</span>
      <input type="file" accept="image/png,image/jpeg,image/webp" onChange={(event) => {
        const file = event.target.files?.[0];
        if (!file) return;
        onChange({ fileName: file.name, previewUrl: URL.createObjectURL(file) });
      }} />
      <div className="vendor-detail__upload-box">
        {hasPreview ? <img src={value} alt="Product preview" /> : <strong>{value || "Choose product image"}</strong>}
        <small>PNG, JPG, or WebP. The API upload can be connected later.</small>
      </div>
    </label>
  );
};

const Modal = ({ title, description, children, onClose, onSave, saveLabel = "Save" }) => (
  <div className="vendor-detail__modal-backdrop" role="presentation">
    <div className="vendor-detail__modal" role="dialog" aria-modal="true" aria-label={title}>
      <div className="vendor-detail__modal-header"><div><h3>{title}</h3>{description && <p>{description}</p>}</div><button type="button" onClick={onClose}>×</button></div>
      <div className="vendor-detail__modal-body">{children}</div>
      <div className="vendor-detail__modal-footer"><button className="vendor-detail__secondary-btn" type="button" onClick={onClose}>Cancel</button><button className="vendor-detail__primary-btn" type="button" onClick={onSave}>{saveLabel}</button></div>
    </div>
  </div>
);

const VendorDetailPage = ({ mode = "view" }) => {
  const navigate = useNavigate();
  const { vendorId } = useParams();
  const isCreate = mode === "create" || vendorId === "create";
  const isEdit = mode === "edit" || isCreate;
  const sourceVendor = useMemo(() => (isCreate ? defaultVendor : vendorRecords[vendorId] || vendorRecords["hikari-house"]), [isCreate, vendorId]);

  const [vendor, setVendor] = useState(sourceVendor);
  const [selectedOutletIndex, setSelectedOutletIndex] = useState(0);
  const [draftOutlet, setDraftOutlet] = useState(makeOutlet());
  const [draftProduct, setDraftProduct] = useState(makeProduct());
  const [activeModal, setActiveModal] = useState(null);
  const [message, setMessage] = useState("");

  const outlets = vendor.outlets || [];
  const selectedOutlet = outlets[selectedOutletIndex] || outlets[0] || makeOutlet();
  const selectedProduct = selectedOutlet.product || makeProduct();
  const activeProductCount = outlets.filter((outlet) => outlet.product?.status === "Available").length;
  const outletCount = outlets.length;
  const totalDailyQuantity = outlets.reduce((sum, outlet) => sum + Number(outlet.product?.dailyQuantity || 0), 0);
  const totalDailySold = outlets.reduce((sum, outlet) => sum + Number(outlet.product?.dailySold || 0), 0);

  const updateVendor = (field, value) => setVendor((current) => {
    const next = { ...current, [field]: value };
    if (["bankName", "bankAccountNumber"].includes(field)) next.bank = formatBankAccount(next.bankName, next.bankAccountNumber);
    return next;
  });
  const updateOutlet = (field, value) => setDraftOutlet((current) => ({ ...current, [field]: value }));
  const updateProduct = (field, value) => setDraftProduct((current) => ({ ...current, [field]: value }));

  const openAddOutletModal = () => {
    setDraftOutlet(makeOutlet({ phone: vendor.contact, city: vendor.city || "Kuching" }));
    setActiveModal("outlet-add");
  };
  const openEditOutletModal = (index = selectedOutletIndex) => {
    setSelectedOutletIndex(index);
    setDraftOutlet(outlets[index] || makeOutlet());
    setActiveModal("outlet-edit");
  };
  const openProductModal = (index = selectedOutletIndex) => {
    setSelectedOutletIndex(index);
    setDraftProduct((outlets[index] || makeOutlet()).product || makeProduct());
    setActiveModal("product");
  };

  const handleSave = () => {
    setMessage(isCreate ? "Vendor created successfully. You can add outlets from this admin screen." : "Vendor details saved. API connection can be added later.");
    if (isCreate && vendor.name) navigate(`/admin/vendors/${slugify(vendor.name)}`, { replace: true });
  };
  const saveOutlet = () => {
    setVendor((current) => {
      const nextOutlets = [...(current.outlets || [])];
      if (activeModal === "outlet-add") {
        nextOutlets.push({ ...draftOutlet, product: draftOutlet.product || makeProduct() });
        setSelectedOutletIndex(nextOutlets.length - 1);
      } else {
        nextOutlets[selectedOutletIndex] = { ...draftOutlet, product: nextOutlets[selectedOutletIndex]?.product || makeProduct() };
      }
      return { ...current, city: nextOutlets[0]?.city || current.city, outlets: nextOutlets };
    });
    setActiveModal(null);
    setMessage("Outlet setup saved. Vendors can have multiple outlets, but only admin can create or manage outlets.");
  };
  const saveProduct = () => {
    setVendor((current) => {
      const nextOutlets = [...(current.outlets || [])];
      nextOutlets[selectedOutletIndex] = { ...(nextOutlets[selectedOutletIndex] || makeOutlet()), product: draftProduct };
      return { ...current, outlets: nextOutlets };
    });
    setActiveModal(null);
    setMessage("Product setup saved. Each outlet is restricted to one product for this MVP.");
  };
  const handleSendSetupEmail = () => setMessage(`Welcome email prepared for ${vendor.email || "this vendor"}. It contains the portal link, login email, temporary password, and setup steps.`);
  const handleDeactivate = () => {
    setVendor((current) => ({ ...current, status: current.status === "Inactive" ? "Active" : "Inactive" }));
    setMessage(vendor.status === "Inactive" ? "Vendor reactivated." : "Vendor deactivated. Order history is preserved.");
  };

  return (
    <div className="vendor-detail">
      <section className="vendor-detail__header">
        <div>
          <button className="vendor-detail__back" type="button" onClick={() => navigate("/admin/vendors")}>← Back to Vendors</button>
          <p className="vendor-detail__eyebrow">SecondBite Admin</p>
          <h2>{isCreate ? "Create Vendor" : vendor.name}</h2>
          <p>{isCreate ? "Add a vendor profile first. Admin can add multiple outlets after the vendor is created." : "Review vendor profile, multiple outlet setup, one product per outlet, and order activity."}</p>
        </div>
        <div className="vendor-detail__header-actions">
          {!isCreate && <span className={`vendor-detail__status vendor-detail__status--${statusClass(vendor.status)}`}>{vendor.status}</span>}
          {!isEdit && <button type="button" onClick={() => navigate(`/admin/vendors/${vendorId}/edit`)}>Edit Vendor</button>}
          {isEdit && <button type="button" onClick={handleSave}>Save Vendor</button>}
        </div>
      </section>

      {message && <div className="vendor-detail__notice">{message}</div>}

      <section className="vendor-detail__summary-grid">
        <InfoItem label="Contact" value={vendor.contact} />
        <InfoItem label="City / Area" value={vendor.city} />
        <InfoItem label="Outlets" value={`${outletCount} outlet${outletCount === 1 ? "" : "s"}`} />
        <InfoItem label="Products" value={`${activeProductCount} active`} />
      </section>

      <section className="vendor-detail__content-grid">
        <div className="vendor-detail__panel vendor-detail__panel--wide">
          <div className="vendor-detail__panel-title"><h3>Vendor Profile</h3></div>
          {isEdit ? (
            <div className="vendor-detail__form-grid">
              <TextField label="Vendor Name" value={vendor.name} placeholder="Enter vendor name" onChange={(value) => updateVendor("name", value)} />
              <TextField label="Contact Number" value={vendor.contact} placeholder="012-3456789" onChange={(value) => updateVendor("contact", value)} />
              <TextField label="Email" value={vendor.email} placeholder="vendor@example.com" onChange={(value) => updateVendor("email", value)} />
              <TextField label="Person In Charge" value={vendor.pic} placeholder="PIC name" onChange={(value) => updateVendor("pic", value)} />
              <TextField label="Address" value={vendor.address} placeholder="Vendor billing address" onChange={(value) => updateVendor("address", value)} />
              <TextField label="Joined Date" value={vendor.joinedDate} placeholder="12 Jun 2026" onChange={(value) => updateVendor("joinedDate", value)} />
              <TextField label="Bank Name" value={vendor.bankName} placeholder="Maybank" onChange={(value) => updateVendor("bankName", value)} />
              <TextField label="Receiver Name" value={vendor.bankReceiverName} placeholder="Account receiver name" onChange={(value) => updateVendor("bankReceiverName", value)} />
              <TextField label="Account Number" value={vendor.bankAccountNumber} placeholder="51422188" onChange={(value) => updateVendor("bankAccountNumber", value)} />
              <label className="vendor-detail__field"><span>Status</span><select value={vendor.status} onChange={(event) => updateVendor("status", event.target.value)}><option>Active</option><option>Inactive</option><option>Pending Setup</option></select></label>
            </div>
          ) : (
            <div className="vendor-detail__profile-grid">
              <InfoItem label="Vendor Name" value={vendor.name} />
              <InfoItem label="Person In Charge" value={vendor.pic} />
              <InfoItem label="Email" value={vendor.email} />
              <InfoItem label="Joined Date" value={vendor.joinedDate} />
              <InfoItem label="Address" value={vendor.address} />
              <InfoItem label="Bank Name" value={vendor.bankName} />
              <InfoItem label="Receiver Name" value={vendor.bankReceiverName} />
              <InfoItem label="Account Number" value={vendor.bankAccountNumber} />
            </div>
          )}
        </div>

        <div className="vendor-detail__panel">
          <div className="vendor-detail__panel-title"><h3>Quick Actions</h3></div>
          {!isCreate && <button className="vendor-detail__action vendor-detail__action--muted" type="button" onClick={handleSendSetupEmail}>Resend Welcome Email</button>}
          {!isCreate && <button className="vendor-detail__action vendor-detail__action--danger" type="button" onClick={handleDeactivate}>{vendor.status === "Inactive" ? "Reactivate Vendor" : "Deactivate Vendor"}</button>}
        </div>

        <div className="vendor-detail__panel vendor-detail__panel--wide">
          <div className="vendor-detail__panel-title"><h3>Sales Summary</h3><p>Today's sales snapshot across all outlets.</p></div>
          <div className="vendor-detail__sales-grid">
            <InfoItem label="Sales Today" value={formatPrice(vendor.salesToday)} />
            <InfoItem label="Orders Today" value={vendor.ordersToday} />
            <InfoItem label="Paid Orders" value={vendor.paidOrders} />
            <InfoItem label="Pending Orders" value={vendor.pendingOrders} />
            <InfoItem label="Total Daily Quantity" value={totalDailyQuantity || "-"} />
            <InfoItem label="Total Daily Sold" value={totalDailySold || vendor.soldToday || "0"} />
          </div>
        </div>

        <div className="vendor-detail__panel vendor-detail__panel--wide">
          <div className="vendor-detail__panel-title">
            <h3>Outlets Summary</h3>
            <p>Outlet setup and product setup have moved to the outlet detail page.</p>
          </div>
          <div className="vendor-detail__table">
            <div className="vendor-detail__table-head vendor-detail__table-head--outlets"><span>Outlet</span><span>City</span><span>Operating Hours</span><span>Product</span><span>Status</span><span>Action</span></div>
            {outlets.length ? outlets.map((outlet, index) => (
              <div className={`vendor-detail__table-row vendor-detail__table-row--outlets${selectedOutletIndex === index ? " vendor-detail__table-row--selected" : ""}`} key={`${outlet.name}-${index}`} onClick={() => setSelectedOutletIndex(index)}>
                <span>{outlet.name || "No outlet yet"}</span>
                <span>{outlet.city || "-"}</span>
                <span>{outlet.openTime && outlet.closeTime ? `${outlet.openTime} - ${outlet.closeTime}` : "-"}</span>
                <span>{outlet.product?.name || "No product yet"}</span>
                <span className={`vendor-detail__status vendor-detail__status--${statusClass(outlet.status)}`}>{outlet.status}</span>
                <span><button className="vendor-detail__link-btn" type="button" onClick={(event) => { event.stopPropagation(); navigate(`/admin/vendors/${vendorId}/outlets/${index + 1}`); }}>View Outlet</button></span>
              </div>
            )) : <div className="vendor-detail__table-empty">No outlet yet. Create outlets from the outlet page.</div>}
          </div>
        </div>
      </section>

    </div>
  );
};

export default VendorDetailPage;
